import { GuestsRepository } from './guest.repository';
import { ManifestsRepository } from './manifests.repository';
import { ProductsRepository } from './products.repository';

export const repos = [ManifestsRepository, ProductsRepository, GuestsRepository];

export * from './guest.repository';
export * from './manifests.repository';
export * from './products.repository';
